module.exports = __webpack_public_path__ + "img/riskIndicator.24c7f792.png";